import api from "./api";

export function unwrapNotificationsPayload(data) {
  if (Array.isArray(data)) {
    return { results: data, unread_count: data.filter((n) => !n.is_read).length, count: data.length };
  }
  const results = Array.isArray(data?.results) ? data.results : [];
  return {
    results,
    unread_count: Number(data?.unread_count ?? results.filter((n) => !n.is_read).length),
    count: Number(data?.count ?? results.length),
  };
}

export const fetchNotifications = (params = {}) => api.get("/notifications/", { params });
export const markNotificationRead = (id) => api.post(`/notifications/${id}/read/`);
export const markAllNotificationsRead = () => api.post("/notifications/read-all/");
export const fetchAdminBroadcastHistory = () => api.get("/notifications/admin/notices/history/");
